<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K3q1RX/tc-custom/9781464203787.jpg?1729937559338" alt="This image is the cover for the book Capital Crimes, British Library Crime Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Capital Crimes, British Library Crime Classics
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An eclectic collection of London-based crime stories from the Golden Age of </b><b>Mystery, featuring work by Arthur Conan Doyle, Edgar Wallace and others.</b></p><p><i>Capital Crimes</i> presents seventeen tales of murder and mayhem that blend the familiar with the unexpected in a way that reflects the personality of London. Alongside classics by Margery Allingham, Anthony Berkeley and Thomas Burke are excellent and unusual stories by authors who are far less well known. The stories give a flavor of how writers have tackled crime in London over the span of more than half a century. Their contributions range from grizzly vignettes, cerebral whodunits, and an early serial-killer thriller set on the London Underground. What they have in common is an atmospheric London setting, and enduring value as entertainment. </p><p> Each story is introduced by the editor, Martin Edwards, who sheds light on the authors' lives and the background to their writing. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Edwards
      </h2>
      
      <p class="authorDescription body article"><P>Martin Edwards is an award-winning crime writer best known for two series of novels set in Liverpool and the Lake District. He is series consultant for British Library Crime Classics, the Vice Chair of the Crime Writers' Association, and President of the Detection Club. The Golden Age of Murder, his study of the Detection Club, was published in 2015 to international acclaim, and has been nominated for both the Edgar and Agatha awards for the year's best book about the genre. He received the CWA 2020 Diamond Dagger Award for sustained excellence in crime writing and significant contributions to the genre, joining the ranks of Sue Grafton, Ian Rankin, and Lee Child.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69a6e877